import { redirect as NextRedirect, type RedirectType } from "next/navigation";
import { env } from "~/env.mjs";
import { config } from "../i18n/config";

export const getApiUrl = (locale?: string): string => {
	if (process.env.NODE_ENV === "development" && env.NEXT_PUBLIC_API_URL) {
		return env.NEXT_PUBLIC_API_URL;
	}

	if (locale) {
		const domain = config.domains.find((domain) => domain.locales.includes(locale));

		if (domain?.api) {
			const url = domain.api[locale];

			if (url) return url;
		}
	}

	throw new Error(`No API url found for locale: '${locale ?? ""}'`);
};

export function redirect(url: string, lang: string, type?: RedirectType): never {
	const domain = config.domains.find((domain) => domain.locales.includes(lang));
	const prefix = lang !== domain?.defaultLocale ? `/${lang}` : "";

	return NextRedirect(!url?.startsWith(prefix) ? `${prefix}${url}` : url, type);
}
